// Driver Types based on API specification

export interface DriverCapacity {
  id: string;
  vehicle_type: string;
  name_translations: {
    en: string;
    ar: string;
  };
  max_capacity_m3: number;
  max_shipments: number;
  max_weight_kg: number;
  is_active: boolean;
}

export interface DriverDetails {
  // Basic Info
  id: string;
  carrier_user_id: string;
  capacity_id: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;

  // Personal Information
  name: string;
  phone: string;
  email: string | null;

  // Payment Information
  payment_type: 'salary' | 'commission';
  commission_rate: string | number;
  per_trip_bonus: number;

  // Vehicle & Capacity Information (optional when capacity_id is null)
  vehicle_type?: string;
  capacity_name?: {
    en: string;
    ar: string;
  };

  // Carrier Information
  carrier_id?: string;
  carrier_name: string;

  // Current Load & Capacity Statistics
  current_shipments: number;
  used_capacity_m3: string | number;
  used_weight_kg: string | number;

  // Computed Available Capacity (optional when capacity_id is null)
  available_capacity_m3?: number;
  available_slots?: number;
  available_weight_kg?: number;

  // Full capacity object (null when no capacity assigned)
  capacity?: DriverCapacity | null;
}

export interface DriverDetailsResponse {
  success: boolean;
  data: DriverDetails;
  message: string;
}

// Vehicle type icons mapping
export const vehicleTypeIcons: Record<string, string> = {
  motorcycle: '🏍️',
  van: '🚐',
  truck: '🚛',
  car: '🚗',
  bicycle: '🚲',
};

// Vehicle type labels
export const vehicleTypeLabels: Record<string, { en: string; ar: string }> = {
  motorcycle: { en: 'Motorcycle', ar: 'دراجة نارية' },
  van: { en: 'Van', ar: 'شاحنة صغيرة' },
  truck: { en: 'Truck', ar: 'شاحنة' },
  car: { en: 'Car', ar: 'سيارة' },
  bicycle: { en: 'Bicycle', ar: 'دراجة' },
};
